<template>
  <div class="layout layout--checkout">
    <CheckoutHeader class="layout__checkout-header" />

    <main
      id="main"
      class="layout__main layout__checkout-main"
    >
      <slot />
    </main>

    <CheckoutFooter class="layout__checkout-footer" />

    <CartRestore />
  </div>
</template>

<style>
@import url("~layers/app/layouts/default.css");
@import url("~layers/app/layouts/checkout.css");
</style>
